import { UserAddOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Radio, Row, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { ContentBox } from "../../../components/layout/content";
import { LoginedLayout } from "../../../components/layout/loginLayout";
import { DEPARTMENT } from "../../../constants/option";
import { UserContext } from "../../../context/userContext";
import { POST } from "../../../services";
import { CHECHKER_INSERT_NEW_USER, CHECKER_POST_DUPLICATE_USER } from "../../../services/path";
import ModalUserDcom from "./view";

const UserManage = () => {
  const [form] = Form.useForm();
  const [userType, setUserType] = useState(2);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const [isFailModalVisible, setIsFailModalVisible] = useState(false);
  const [user_id, setUser_id] = useState("");
  const { user } = useContext(UserContext);

  const handleSuccessModalOk = () => {
    setIsSuccessModalVisible(false);
    form.resetFields();
  };

  const handleFailModalOk = () => {
    setIsFailModalVisible(false);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        POST(CHECKER_POST_DUPLICATE_USER, { username: values.username })
          .then((response) => {
            const isUsernameDuplicate = response.IsFound;
            if (isUsernameDuplicate) {
              setIsFailModalVisible(true);
            } else {
              const userData = {
                user_id: user_id,
                username: values.username,
                password: values.password,
                firstname: values.firstname,
                lastname: values.lastname,
                nickname: values.nickname,
                role_id: values.role_id,
                modified_by: user.user_id,
              };

              POST(CHECHKER_INSERT_NEW_USER, userData)
                .then((response) => {
                  console.log("User added successfully:", response);
                  setIsSuccessModalVisible(true);
                })
                .catch((error) => {
                  console.error("Error adding user:", error);
                });
            }
          })
          .catch((error) => {
            console.error("Error checking username:", error);
          });
      })
      .catch((error) => {
        console.error("Form validation error:", error);
      });
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleUserSelect = (user: any) => {
    setUser_id(user.user_id);
    form.setFieldsValue({
      user_id: user.user_id,
      username: user.username,
      firstname: user.firstname,
      lastname: user.lastname,
      nickname: user.nickname,
      password: user.password,
    });
  };

  const handleUserTypeChange = (e: any) => {
    setUserType(e.target.value);
    form.resetFields();
  };

  useEffect(() => {
    setUserType(3);
  }, []);

  return (
    <LoginedLayout>
      <ContentBox>
        <div
          style={{ marginBottom: "16px", borderBottom: "1px solid #e8e8e8", paddingBottom: "8px" }}
        >
          <h2 style={{ marginBottom: "8px" }}>เพิ่ม/แก้ไข พนักงานทั้งหมด</h2>
        </div>
        <Form form={form}>
          <Form.Item label="ประเภทพนักงาน" name="userType" style={{ marginBottom: "16px" }}>
            <Radio.Group
              onChange={handleUserTypeChange}
              value={userType}
              style={{ marginBottom: "10px" }}
            >
              <Radio value={1}>Dcom</Radio>
              <Radio value={2}>คนไทย</Radio>
              <Radio value={3}>ต่างชาติ</Radio>
            </Radio.Group>
            <Button
              type="primary"
              icon={<UserAddOutlined />}
              onClick={handleOpenModal}
              disabled={userType !== 1}
            >
              Choose User
            </Button>
            <ModalUserDcom
              visible={isModalVisible}
              onCancel={handleCloseModal}
              onSelectUser={handleUserSelect}
            />
          </Form.Item>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={11}>
              <Form.Item
                label="Username"
                labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
                name="username"
                rules={[{ required: true, message: "กรุณาใส่ username!" }]}
              >
                <Input placeholder="กรุณาใส่ username" disabled={userType === 1} />
              </Form.Item>
              <Form.Item
                label="ชื่อจริง"
                labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
                name="firstname"
                rules={[{ required: true, message: "กรุณาใส่ชื่อจริง!" }]}
              >
                <Input placeholder="กรุณาใส่ ชื่อจริง" disabled={userType === 1} />
              </Form.Item>
              <Form.Item
                label="ชื่อเล่น"
                labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
                name="nickname"
                rules={[{ required: true, message: "กรุณาใส่ชื่อเล่น!" }]}
              >
                <Input placeholder="กรุณาใส่ ชื่อเล่น" disabled={userType === 1} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                label="รหัสผ่าน"
                labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
                name="password"
                rules={[{ required: true, message: "กรุณาใส่รหัสผ่าน!" }]}
              >
                <Input.Password
                  type="password"
                  placeholder="กรุณาใส่ รหัสผ่าน"
                  disabled={userType === 1}
                />
              </Form.Item>
              <Form.Item
                label="นามสกุล"
                labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
                name="lastname"
                rules={[{ required: true, message: "กรุณาใส่นามสกุล!" }]}
              >
                <Input placeholder="กรุณาใส่ นามสกุล" disabled={userType === 1} />
              </Form.Item>
              <Form.Item
                label="ระดับหน้าที่"
                labelCol={{ xs: { span: 24 }, sm: { span: 8 } }} // Adjust the label width for different screen sizes
                wrapperCol={{ xs: { span: 24 }, sm: { span: 16 } }} // Adjust the input field width for different screen sizes
                name="role_id"
                rules={[
                  { required: true, message: "กรุณาเลือกแผนก!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value !== 0) {
                        return Promise.resolve();
                      }
                      return Promise.reject("กรุณาเลือกแผนก!");
                    },
                  }),
                ]}
              >
                <Select
                  placeholder="====== กรุณาเลือกหน้าที่ ======"
                  style={{ textAlign: "center" }}
                >
                  {DEPARTMENT.map((item) => (
                    <Select.Option key={item.value} value={item.value}>
                      {item.label} {/* Use item.label as the display value */}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{ textAlign: "center" }}>
            <Button type="primary" onClick={handleSubmit}>
              Submit
            </Button>
          </Form.Item>
        </Form>
        <Modal
          title="Success"
          visible={isSuccessModalVisible}
          onOk={handleSuccessModalOk}
          onCancel={handleSuccessModalOk}
          footer={[
            <Button key="ok" type="primary" onClick={handleSuccessModalOk}>
              OK
            </Button>,
          ]}
        ></Modal>
        <Modal
          title="Fail"
          visible={isFailModalVisible}
          onOk={handleFailModalOk}
          onCancel={handleFailModalOk}
          footer={[
            <Button key="ok" type="primary" onClick={handleFailModalOk}>
              OK
            </Button>,
          ]}
        ></Modal>
      </ContentBox>
    </LoginedLayout>
  );
};

export default UserManage;
